const Component = () => import('./NoMatchPage');

export { Component };
